import { render, staticRenderFns } from "./SelectBackhaulProvider.vue?vue&type=template&id=b4c494d8"
import script from "./SelectBackhaulProvider.vue?vue&type=script&lang=js"
export * from "./SelectBackhaulProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports